import React from "react";
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { list } from "./DataList.module.scss";

const DataList = ({ className, ...props }) => (
  <dl className={classNames(list, className)} {...props} />
);

DataList.propTypes = {
  className: PropTypes.string
};

DataList.defaultProps = {
  className: ""
};

export default DataList;
